// The Garden Vocabulary — the ONLY status system across the admin surface.
// Per mem/constitution/silver-sage-principles.md, every operational state must
// map to one of these five phases. No ad-hoc statuses ("Active", "Pending",
// "Open", "Error") anywhere in the executive UI.

export type GardenPhase =
  | "growing"     // 🌱 In progress, healthy motion
  | "waiting"    // ⏳ Waiting on someone/something external
  | "needs_care" // 🪴 Requires attention from the Director
  | "thriving"   // 🌿 Complete and well
  | "wrapped_up"; // 🍂 Concluded, archived

export interface GardenStatusMeta {
  phase: GardenPhase;
  label: string;
  emoji: string;
  /** Tailwind classes for a soft, calm badge. Never harsh. */
  tone: string;
  description: string;
}

export const GARDEN: Record<GardenPhase, GardenStatusMeta> = {
  growing: {
    phase: "growing",
    label: "Growing",
    emoji: "🌱",
    tone: "bg-sage/10 text-sage border-sage/25",
    description: "Underway and healthy.",
  },
  waiting: {
    phase: "waiting",
    label: "Waiting",
    emoji: "⏳",
    tone: "bg-amber-500/10 text-amber-700 border-amber-500/25 dark:text-amber-400",
    description: "Held pending someone else's step.",
  },
  needs_care: {
    phase: "needs_care",
    label: "Needs Care",
    emoji: "🪴",
    tone: "bg-terracotta/10 text-terracotta border-terracotta/25",
    description: "Waiting on you to make a decision.",
  },
  thriving: {
    phase: "thriving",
    label: "Thriving",
    emoji: "🌿",
    tone: "bg-emerald-500/10 text-emerald-700 border-emerald-500/25 dark:text-emerald-400",
    description: "Complete and well.",
  },
  wrapped_up: {
    phase: "wrapped_up",
    label: "Wrapped Up",
    emoji: "🍂",
    tone: "bg-muted text-muted-foreground border-border",
    description: "Concluded and tucked away.",
  },
};

export const gardenPhase = (p: GardenPhase) => GARDEN[p];
